import { render, staticRenderFns } from "./VideoGreetingModal.vue?vue&type=template&id=09566e12&scoped=true"
import script from "./VideoGreetingModal.vue?vue&type=script&lang=js"
export * from "./VideoGreetingModal.vue?vue&type=script&lang=js"
import style0 from "./VideoGreetingModal.vue?vue&type=style&index=0&id=09566e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09566e12",
  null
  
)

export default component.exports